import { render, staticRenderFns } from "./ShippableAddress.vue?vue&type=template&id=21a7f17b"
import script from "./ShippableAddress.vue?vue&type=script&lang=js"
export * from "./ShippableAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ShippableAddress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a7f17b')) {
      api.createRecord('21a7f17b', component.options)
    } else {
      api.reload('21a7f17b', component.options)
    }
    module.hot.accept("./ShippableAddress.vue?vue&type=template&id=21a7f17b", function () {
      api.rerender('21a7f17b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/address/ShippableAddress.vue"
export default component.exports